import { toPng } from "html-to-image";
export async function captureScreenshot() {
    return toPng(document.body).then((dataUrl) => dataUrl.replace(/^data:image\/png;base64,/, ""));
}
//# sourceMappingURL=screenshot.js.map